namespace $.$$ {
	export class $hyoo_about extends $.$hyoo_about {

	}

}
